module.exports = __webpack_public_path__ + "img/3.86d91c43.jpg";